// FilterList
import React from 'react';
import PropTypes from 'prop-types';

const FilterTabItem = ({ filterClick, option }) => (
  <li key={option.name.toLowerCase().replace(/[\s]+/g, '-')} className={(option.isChecked === true ? 'in-page-nav-item active' : 'in-page-nav-item')} role="presentation">
    <button role="tab" aria-selected={(option.isChecked === true ? 'true' : 'false')} aria-expanded={(option.isChecked === true ? 'true' : 'false')} id={option.name.toLowerCase().replace(/[\s]+/g, '-')} onClick={() => filterClick(option)}>
      {option.name}
    </button>
  </li>
);

FilterTabItem.propTypes = {
  filterClick: PropTypes.func.isRequired,
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isChecked: PropTypes.bool.isRequired,
  }),
};

const FilterSelectBoxItem = ({ option }) => (
  <option key={option.name.toLowerCase().replace(/[\s]+/g, '-')} value={option.name}>
    {option.name}
  </option>
);

FilterSelectBoxItem.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

export {
  FilterTabItem,
  FilterSelectBoxItem,
};
